<template>
  <div class="is-flex">
    <div v-for="(status, index) in computedStatus" :key="index" class="ml-24px">
      <status-badge :badge="status.badge" :count="status.count" />
    </div>
    <div v-if="isSpecificCount > 0" class="ml-24px">
      <status-badge :isSpecific="true" :count="isSpecificCount" />
    </div>
  </div>
</template>

<script>
import StatusBadge from '@/components/indicator/status-badge'
import IndicatorHelper from '@/helpers/indicator-helper'

export default {
  components: {
    StatusBadge
  },
  props: {
    indicators: Array,
    isSpecificCount: Number
  },
  computed: {
    computedStatus() {
      return IndicatorHelper.getGroupedStatusBadges(this.indicators)
    }
  }
}
</script>
